import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [company, setCompany] = useState("");
  const [state, setState] = useState("ready");
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    setState("sending");
    try {
      await axios.post(`${API}/contact`, { name, email, message, company });
      setState("sent");
    } catch (e) {
      const detail = e.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Something went wrong — try again.");
      setState("ready");
    }
  };

  const inputCls =
    "w-full h-12 bg-transparent border border-white/20 focus:border-volt px-4 font-plex text-xs uppercase tracking-[0.2em] text-white placeholder:text-white/30 outline-none transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <header className="px-6 md:px-10 py-6 border-b border-white/10 flex items-center justify-between">
        <Link to="/">
          <img src="/breethe-logo.webp" alt="Breethe" className="h-8 w-auto" />
        </Link>
        <span className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40">
          Contact
        </span>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div data-testid="contact-page" className="w-full max-w-xl border border-white/10 bg-[#121212] p-8 md:p-12">
          {state === "sent" ? (
            <div data-testid="contact-success">
              <p className="font-anton uppercase text-3xl md:text-4xl leading-none">
                Message received<span className="text-volt">.</span>
              </p>
              <p className="mt-4 text-white/60 font-light">
                Thanks for reaching out — we read everything and usually reply within a day or two.
              </p>
              <Link
                to="/"
                data-testid="contact-success-home"
                className="mt-8 inline-block font-plex text-[11px] uppercase tracking-[0.25em] text-volt hover:text-volt-dark transition-colors duration-300"
              >
                Back to Breethe
              </Link>
            </div>
          ) : (
            <>
              <p className="font-anton uppercase text-3xl md:text-4xl leading-none">
                Talk to us<span className="text-volt">.</span>
              </p>
              <p className="mt-3 text-white/60 font-light text-sm md:text-base">
                Orders, stockists, press, or just want to argue about mouth tape — fire away.
                Prefer email?{" "}
                <a href="mailto:info@breethe.com.au" className="text-volt hover:text-volt-dark transition-colors duration-300">
                  info@breethe.com.au
                </a>
              </p>

              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="YOUR NAME"
                data-testid="contact-name-input"
                className={`${inputCls} mt-8`}
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="YOUR EMAIL"
                data-testid="contact-email-input"
                className={`${inputCls} mt-4`}
              />
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="WHAT'S ON YOUR MIND?"
                data-testid="contact-message-input"
                rows={5}
                className="mt-4 w-full bg-transparent border border-white/20 focus:border-volt p-4 font-light text-sm text-white placeholder:text-white/30 outline-none transition-colors duration-300 resize-none"
              />
              <input
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="hidden"
                style={{ display: "none" }}
              />
              {error && (
                <p data-testid="contact-error" className="mt-3 font-plex text-xs text-volt">
                  {error}
                </p>
              )}
              <button
                onClick={submit}
                disabled={state === "sending"}
                data-testid="contact-submit-button"
                className="mt-6 w-full h-14 bg-volt text-black font-anton uppercase tracking-wider text-base transition-[background-color,transform] duration-200 hover:bg-volt-dark active:scale-[0.98] disabled:opacity-60"
              >
                {state === "sending" ? "Sending…" : "Send message"}
              </button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
